import { configureStore } from '@reduxjs/toolkit'

import menuSlice from './Slices/MenuSlice'
import messagesSlice from './Slices/MessagesSlice'
import boxesSlice from './Slices/BoxesSlice'
import boxLabelsSlice from './Slices/BoxLabelsSlice'
import meSlice from './Slices/MeSlice'
import activitiesSlice from './Slices/ActivitiesSlice'
import DraftsSlice from './Slices/DraftsSlice'
import NotificationsSlice from './Slices/NotificationsSlice'
import ContainersMapSlice from './Slices/ContainersMapSlice'
import { publish, subscribe } from '../event-bus'
import ThreadsSlice from './Slices/ThreadsSlice'
import ContactsSlice from './Slices/ContactsSlice'
import ContactsLabelsSlice from './Slices/ContactsLabelsSlice'

const store = configureStore({
  reducer: {
    menu: menuSlice,
    messages: messagesSlice,
    boxes: boxesSlice,
    boxlabels: boxLabelsSlice,
    me: meSlice,
    activities: activitiesSlice,
    drafts: DraftsSlice,
    notifications: NotificationsSlice,
    containers: ContainersMapSlice,
    threads: ThreadsSlice,
    contacts: ContactsSlice,
    contactlabels: ContactsLabelsSlice
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }),
})

store.commit = publish
store.on = subscribe

export default store
